import React from 'react';
import { STATUS_COLORS, STATUS_LABELS, type TicketStatus } from './statuses';

interface Props {
  status: TicketStatus | string;
  size?: 'sm' | 'md';
}

export const TicketStatusPill: React.FC<Props> = ({ status, size = 'md' }) => {
  const key = (status as TicketStatus) in STATUS_COLORS ? (status as TicketStatus) : 'new';
  const colors = STATUS_COLORS[key];
  const label = STATUS_LABELS[key] || status;

  const isSmall = size === 'sm';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: isSmall ? '2px 8px' : '4px 10px',
        borderRadius: 100,
        background: colors.bg,
        color: colors.text,
        fontSize: isSmall ? 11 : 12,
        fontWeight: 600,
        letterSpacing: '0.01em',
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 6,
          height: 6,
          borderRadius: 10,
          background: colors.dot,
        }}
      />
      {label}
    </span>
  );
};
